// One holder may ask the kernel to wait before it starts the next plugin (whiteboard G4, 2026-10-20:
// a visit's card waited 340-775 ms behind plugin starts right after a reload). The cap stops a stuck holder.
export function createHold({ capMs = 1500 } = {}) {
  let holder = null
  return {
    set(fn) {
      holder = fn
      return {
        dispose() {
          if (holder === fn) holder = null
        },
      }
    },
    async wait() {
      let p
      try {
        p = holder?.()
      } catch (e) {
        console.error('[omni] start hold failed:', e)
        return
      }
      if (!p || typeof p.then !== 'function') return
      let timer
      const cap = new Promise((resolve) => {
        timer = setTimeout(resolve, capMs)
      })
      const held = Promise.resolve(p).catch((e) => {
        console.error('[omni] start hold rejected:', e)
      })
      await Promise.race([held, cap])
      clearTimeout(timer)
    },
  }
}
